var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"narrative-card"},[_c('h3',[_vm._v(_vm._s(_vm.narrativeQuestion))]),_c('NavigationButton',{attrs:{"title":_vm.$t('continue')},nativeOn:{"click":function($event){return _vm.nextStep($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }